import type { Locale } from 'date-fns';
import {
  ar,
  de,
  enUS,
  es,
  fr,
  he,
  id,
  it,
  ja,
  ko,
  ms,
  nl,
  nb,
  pl,
  ru,
  tr,
  uk,
  vi,
  zhCN,
  el,
  ptBR,
  ta,
} from 'date-fns/locale';

// Maps our i18n language codes to date-fns locales.
const LOCALE_MAP: Record<string, Locale> = {
  'en': enUS,
  'es': es,
  'pt': ptBR,
  'de': de,
  'fr': fr,
  'ar': ar,
  'el': el,
  'he': he,
  'id': id,
  'it': it,
  'ja': ja,
  'ko': ko,
  'ms': ms,
  'ta': ta,
  'nl': nl,
  // i18n uses 'no', date-fns provides 'nb' (Bokmål)
  'no': nb,
  'pl': pl,
  'ru': ru,
  'tr': tr,
  'uk': uk,
  'vi': vi,
  // generic Chinese → default to Mainland Simplified
  'zh': zhCN,
};

export function getDateFnsLocale(lang: string | undefined | null): Locale {
  const key = (lang || 'en').toLowerCase();
  return LOCALE_MAP[key] ?? enUS;
}

